import type { BasketItem } from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";
import {
	resolveDeliveryText,
	type DeliveryTextView
} from "~/utils/cart/deliveryText";

export type { DeliveryTextView };

/**
 * Delivery promise for a basket line, keyed on the same Norce flag as the stock
 * status. Rules live in `resolveDeliveryText`; this supplies the store data.
 */
export const useDeliveryText = () => {
	const { getStockStatus } = useStockStatus();
	const appStore = useAppStore();

	const getDeliveryText = (
		item: Partial<BasketItem> | undefined,
		view: DeliveryTextView
	): string =>
		resolveDeliveryText({
			item,
			view,
			statuses: appStore.stockStatus ?? [],
			resolveStatus: getStockStatus
		});

	return { getDeliveryText };
};
